import { LitElement, html, css, PropertyValues } from 'lit';
import {customElement, property} from 'lit/decorators.js'
import GridCSS from './styles/grid'
import { Config, ConfigLanguage } from 'datatables.net'
import datatableCSS from './styles/datatables'
import datatableResponsiveCSS from './styles/datatables-responsive'
import $ from 'jquery'
import 'datatables.net-responsive-dt'
import './styles/iconlibrary'

type ColumnSettings  = Record<string, any>;
type LangSettings    = Record<string, any>
type DTRowMetaData   = { row: number }

const LangSettings: Record<string, ConfigLanguage> = {
    ar: {
        decimal: ".",
        thousands: ",",
        search: "Recherche :",
        lengthMenu: "Afficher _MENU_ entrées",
        info: "Affichage de _START_ à _END_ sur _TOTAL_ entrées",
        infoEmpty: "Affichage de 0 à 0 sur 0 entrées",
        infoFiltered: "(filtré à partir de _MAX_ entrées au total)",
        loadingRecords: "Chargement...",
        zeroRecords: "Aucun enregistrement trouvé",
        emptyTable: "Aucune donnée disponible dans le tableau"	
    },
    fr: {
        decimal: ",",
        thousands: " ",
        search: "Recherche :",
        lengthMenu: "Afficher _MENU_ entrées",
        info: "Affichage de _START_ à _END_ sur _TOTAL_ entrées",
        infoEmpty: "Affichage de 0 à 0 sur 0 entrées",
        infoFiltered: "(filtré à partir de _MAX_ entrées au total)",
        loadingRecords: "Chargement...",
        zeroRecords: "Aucun enregistrement trouvé",
        emptyTable: "Aucune donnée disponible dans le tableau"	
    }
}

const toDate = (data: any, type: 'display' | 'filter' | 'sort' | 'type' | undefined, row: any) => {
	let html = ''
	try {
		let date = new Date(data)
		html = date.toLocaleString('fr-FR')
	}
	catch(e) { console.error(e) }
	finally  { return html }
}


const defaultColumns: ColumnSettings[] = [
    { title: '', data: null, width: "5rem", render: (data: any, type: string, row: any, meta: DTRowMetaData) => meta.row + 1},
    { title: 'date'     , data: 'last_updated'      , defaultContent: ''    , searchable: true, render: toDate, width: "15rem"  },
    { title: 'title'    , data: 'title'     , defaultContent: ''    , searchable: true },
    { visible: false    , data: 'content'   , defaultContent: ''    , searchable: true }
]


@customElement('vxc-chatbot-kpi')

class TChatBotKPI extends LitElement {
  static styles = [
    GridCSS,
    datatableCSS,
    datatableResponsiveCSS, 
    css`
        :host {
            width: 100%;
            font-family: 'Poppins', sans-serif;
            background-color: #f6f9ff;
        }

        h2 {
            font-size: .8rem;
        }

    `]

    @property({ type: Object, attribute: false 				})		stats: Record<string,any>|null = null
    @property({ type: Object, attribute: false              })      userData: Record<string,any>|null = null
    @property({ type: String                                })      host: string = ''
    @property({ type: String, attribute: 'app-uid'          })      uid: string = ''
    @property({ type: String, attribute: 'data-app-var-name'})      varName: string = 'voxy-ai-chat-data'

    private async loadStat() {
        try {
            console.log('loading stats..', `${this.host}/apps/${this.uid}/chat/stats`)
            if(!this.uid)  throw new Error('no app to load')
            const data = await window.voxyapp.get(`${this.host}/apps/${this.uid}/chat/stats`) //await fetch(`${this.host}/apps/${this.app}/chat/stats`)
            if(!data) throw new Error('no stats found')
            this.stats = data
        } 
        catch (e) { console.error('Failed to load application', e) }
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {

        super.firstUpdated(_changedProperties)
    }

    updated(changedProperties: Map<string | number | symbol, unknown>): void {
        if (changedProperties.has('uid') && this.uid?.length) {
            console.log(`'app' changed from ${changedProperties.get('uid')} to ${this.uid}`);
            this.loadStat()
        }
        super.updated(changedProperties)
    }

    render() {
        return html`
            <div class="container-fluid">
                ${this.stats ? html`
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-3">
                        <sales-card 
                            title="Session" 
                            sub-title="number" 
                            icon="chat"
                            value=${this.stats.sessions} 
                            sub-value="" 
                            info=""
                        ></sales-card>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <sales-card 
                            title="Topics" 
                            sub-title="number" 
                            icon="topic"
                            value=${this.stats.topics} 
                            sub-value="" 
                            info=""
                        ></sales-card>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <sales-card 
                            title="Reviews" 
                            sub-title="positive" 
                            icon="thumb-up"
                            value=${this.stats.reviews.positive} 
                            sub-value="" 
                            info=""
                        ></sales-card>					
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <sales-card 
                            title="Reviews" 
                            sub-title="negative" 
                            icon="thumb-down"
                            value=${this.stats.reviews.negative} 
                            sub-value="" 
                            info=""
                        ></sales-card>
                    </div>
                </div>
                    
                    `: ''}

                <div class="row">
                    <div class="col col-md-6 flex-col">
                        <table id="sessions-list"></table>
                    </div>
                    <div class="col col-md-6 flex-col">
                        <table id="topics-list"></table>
                    </div>
                </div>
            </div>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-chatbot-kpi': TChatBotKPI;
  }
}